import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["clinicList", "extendButtons"]

    extend(event) {
        this.clinicListTarget.classList.toggle('h-[400px]')
        this.clinicListTarget.classList.toggle('h-[1816px]')
        this.extendButtonsTarget.classList.toggle('bg-gradient-blacken')

        if (event.target.textContent === 'POKAŻ WIĘCEJ') {
            event.target.textContent = 'POKAŻ MNIEJ'
        } else {
            event.target.textContent = 'POKAŻ WIĘCEJ'
        }
    }
}